import { useQuery } from "@tanstack/react-query";
import {
  photoSeriesSearch,
  PhotoSeriesSearchParams,
} from "common/api/citajteo/photo_series/photo_series";
import { QUERY_KEYS } from "constant/react_query";
import { usePhotoSeriesSearchOptionsFromUrl } from "./useUnitSearchOptionsFromUrl";

type PhotoSeriesSearchOptions = {
  initialSearch: boolean;
};

const INITIAL_PHOTO_SERIES_SEARCH_OPTIONS: PhotoSeriesSearchOptions = {
  initialSearch: true,
};

export const usePhotoSeriesSearchQuery = (
  searchParams?: PhotoSeriesSearchParams,
  {
    initialSearch,
  }: PhotoSeriesSearchOptions = INITIAL_PHOTO_SERIES_SEARCH_OPTIONS
): { data: any; refetch: Function } => {
  const { data, refetch } = useQuery({
    queryKey: [QUERY_KEYS.CITAJTEO_PHOTO_SERIES_SEARCH, searchParams],
    queryFn: async () => {
      const result = await photoSeriesSearch({ ...searchParams });
      return result;
    },
    enabled: initialSearch,
  });

  return { data, refetch };
};

export const usePhotoSeriesSearch = (
  searchParams?: PhotoSeriesSearchParams
) => {
  const { data: unit } = usePhotoSeriesSearchQuery(searchParams);

  const result = typeof unit !== "undefined" && unit !== "" ? unit : null;
  return result;
};

export const usePhotoSeriesSearchRefetch = (
  searchParams?: PhotoSeriesSearchParams
): { data: any; refetch: Function } =>
  usePhotoSeriesSearchQuery(searchParams, { initialSearch: false });

export const usePhotoSeriesUrlSearch = () => {
  const photoSeriesSearchParams = usePhotoSeriesSearchOptionsFromUrl();
  const photoSeriesListResult = usePhotoSeriesSearch(photoSeriesSearchParams);

  return photoSeriesListResult;
};
